import React from 'react';
import { Box, Paper } from 'lib/cortiUI';
export function ScreenRecorderCard({ children }) {
    return (React.createElement(Paper, { elevation: 1 },
        React.createElement(Box, { px: 8, py: 6, overflow: "auto" }, children)));
}
